import React, { useState } from 'react';
import { arrayOf, shape, func, string, bool } from 'prop-types';


const ThreeDotsMenu = ({ options }) => {
    const [showOptions, setShowOptions] = useState(false);

    return (
        <div className="three-dots-component">
            <div className="three-dots-btn" onClick={(e) => {
                if (!showOptions) { // in case outside click will be on button.
                    document.addEventListener('click', () => setShowOptions(false), { once: true });
                }
                e.stopPropagation();
                setShowOptions(true);
            }}>
                <div className="dot" />
                <div className="dot" />
                <div className="dot" />
            </div>
            {showOptions && <div className="options-wrapper">
                {options.map(({ optionText, optionIconUrl, handler, hideOption }) =>
                    !hideOption &&
                    <div
                        key={optionText}
                        onClick={handler}
                        className="option"
                    >
                        {optionIconUrl && <img src={optionIconUrl} alt="option-icon"/>}
                        {optionText}
                    </div>
                )}
            </div>}
        </div>
    )
};

ThreeDotsMenu.propTypes = {
    options: arrayOf(shape({
        optionText: string,
        optionIconUrl: string,
        handler: func,
        showThisOption: bool,
    })).isRequired
};

export default ThreeDotsMenu;
